<template>
  <div class="home">
    <head-top></head-top>
    <!-- <el-container style="height: 100%; border: 1px solid #eee"> -->
    <aside-bar></aside-bar>
    <!-- <el-main class="el-main"> -->
    <router-view></router-view>
    <!-- </el-main> -->
    <!-- </el-container> -->
    <div class="master" v-show="masterShow">
      <div class="master_content" v-if="RechargeData">
        <header>Confirm recharge information</header>
        <section class="userinfo">
          <img :src="RechargeData.userinfo.avatar" alt="" />
          <section>
            <span class="username">{{ RechargeData.userinfo.username }}</span>
            <span class="id">ID: {{ RechargeData.uid }}</span>
          </section>
        </section>
        <section
          class="items"
          v-if="
            !RechargeData.userinfo.isReceive[0] ||
              !RechargeData.userinfo.isReceive[1]
          "
        >
          <p class="info">
            - Users who reach the following goals through your cumulative
            recharge will receive the following rewards, which will be
            automatically issued by the system -
          </p>
          <p
            style="color: #000;font-size:13px;text-align: center;margin-top: 12px;"
          >
            History Recharged for him
            <span style="color:red">{{
              RechargeData.userinfo.historyAmount | formaterDiamond
            }}</span>
          </p>
          <div
            class="rewards"
            :class="{ received: RechargeData.userinfo.isReceive[0] }"
          >
            <div class="re">
              <span>Recharge</span>
              <p>
                <template v-if="RechargeData.userinfo.isReceive[0]">
                  Mission not available
                </template>
                <template v-else>
                  30M <img src="../../assets/diamond.png" alt="" />
                </template>
              </p>
            </div>

            <div class="ii">
              <div class="img">
                <img src="../../assets/marquis.png" alt="" />
              </div>
              <p>Marquis</p>
              <p>*30D</p>
            </div>
            <div class="ii">
              <div class="img">
                <img src="../../assets/id.png" alt="" />
              </div>
              <p>Super ID</p>
              <p>*30D</p>
            </div>
            <div class="ii">
              <div class="img">
                <img src="../../assets/recomend.png" alt="" />
              </div>
              <p>recomend</p>
              <p>*10</p>
            </div>
          </div>
          <div
            class="rewards"
            :class="{ received: RechargeData.userinfo.isReceive[1] }"
          >
            <div class="re">
              <span>Recharge</span>
              <p>
                <template v-if="RechargeData.userinfo.isReceive[1]">
                  Mission not available
                </template>
                <template
                  >100M <img src="../../assets/diamond.png" alt=""
                /></template>
              </p>
            </div>

            <div class="ii">
              <div class="img">
                <img src="../../assets/duke.png" alt="" />
              </div>
              <p>Duke</p>
              <p>*30D</p>
            </div>
            <div class="ii">
              <div class="img">
                <img src="../../assets/id.png" alt="" />
              </div>
              <p>Super ID</p>
              <p>*30D</p>
            </div>
            <div class="ii">
              <div class="img">
                <img src="../../assets/recomend.png" alt="" />
              </div>
              <p>recomend</p>
              <p>*20</p>
            </div>
          </div>
        </section>
        <section class="buttons">
          <span @click="Charge4user" id="sure">Recharge</span
          ><span @click="isMasterShow">Cancel</span>
        </section>
      </div>
    </div>
    <div class="master1" v-show="isSuccess">
      <div class="master_content" v-show="isSuccessChild == true">
        <img src="../../assets/succeed.png" alt="" />
        <span>Confirm recharge information</span>
      </div>
      <div class="master_content1" v-show="isSuccessChild == false">
        <span class="recharging">Recharging...</span>
        <span>Please wait a moment</span>
      </div>
    </div>
    <div class="logout" v-show="islogout">
      <div class="logout_content">
        Sure to log out ?
        <p class="tabs">
          <span @click="logout" id="sure">Sure</span
          ><span @click="islogout_show">Cancel</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import headTop from "../modules/header.vue";
import asideBar from "../modules/aside.vue";
import bus from "@/utils/bus.js";
import { isApp } from "@/utils/changeStyle.js";
export default {
  components: {
    headTop,
    asideBar
  },
  data() {
    return {
      classindex: 0,
      masterShow: false,
      isSuccess: false,
      isSuccessChild: false,
      islogout: false,
      RechargeData: "",
      getStateusername: localStorage.username,
      classArr: [
        {
          title: "Recharge",
          class: "el-icon-coin",
          path: "recharge",
          status: true
        },
        {
          title: "Official recharge",
          class: "el-icon-notebook-2",
          path: "officialrecharge",
          status: true
        },
        {
          title: "Record",
          class: "el-icon-notebook-2",
          path: "record",
          status: true
        },
        {
          title: "Host Statistic",
          class: "el-icon-s-order",
          path: "statistic",
          status: true
        },
        {
          title: "Host Daily Rank",
          class: "el-icon-data-analysis",
          path: "dailyrank",
          status: true
        },
        {
          title: "auto-top-up",
          class: "el-icon-notebook-2",
          path: "auto-top-up",
          status: true
        }
      ]
    };
  },
  filters: {
    formaterDiamond(val) {
      let unit = ["k", "m", "b"];
      let index = -1;
      while (val / 1000 > 1 && index < unit.length) {
        val = val / 1000;
        index++;
      }
      return index < 0 ? val : parseFloat(val.toFixed(2)) + "" + unit[index];
    }
  },
  created() {
    let authority = JSON.parse(localStorage.getItem("authority"));
    let newAuthority = [];
    this.classArr.forEach((value, index) => {
      let status = authority.findIndex(item => value.path === item);
      if (status >= 0) {
        // this.$set(this.classArr[index], "status", false);
        newAuthority.push(this.classArr[index]);
      }
    });
    this.classArr = newAuthority;
    this.classindex = this.classArr.findIndex(
      val => val.path == this.$route.name
    );
  },
  methods: {
    islogout_show() {
      this.islogout = !this.islogout;
      console.log(this.islogout);
    },
    logout() {
      //退出登陆
      this.$http.fetchget(this.$api.logout).then(res => {
        console.log(res);
        if (res.code == 0) {
          localStorage.clear();
          let t = new Date(new Date().getTime() + 100);
          document.cookie = "user=new; expires=" + t.toGMTString();
          this.$router.push("/");
        }
      });
    },
    Charge4user() {
      //充值
      this.isSuccess = true;
      this.masterShow = false;
      this.isSuccessChild = false;
      let url = this.RechargeData.isCustomInput
        ? `${this.$api.disburse_amount}?shortId=${
            this.RechargeData.uid
          }&amount=${this.RechargeData.Diamond}`
        : `${this.$api.disburse}?shortId=${this.RechargeData.uid}&catalogId=${
            this.RechargeData.catalogId
          }`;
      this.$http.fetchpost(url).then(res => {
        if (res.code == 0) {
          this.isSuccessChild = true;
          setTimeout(() => {
            this.isSuccess = false;
          }, 500);
          bus.$emit("getAccount");
        } else if (res.code == 20) {
          this.$message({
            message: "login again",
            type: "warning"
          });
          localStorage.clear();
          this.$router.push("/");
        } else {
          this.isSuccess = false;
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    chilrenClass(index) {
      this.classindex = index;
    },
    isMasterShow() {
      this.masterShow = false;
    },
    isSuccessfn() {
      this.isSuccess = true;
      this.masterShow = false;
      setTimeout(() => {
        this.isSuccessChild = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 1000);
      }, 3000);
    },
    childrenData1(childrenValue) {
      this.RechargeData = childrenValue;
      this.masterShow = childrenValue.masterShow;
      console.log(this.RechargeData);
    }
  },
  computed: {
    isApp() {
      return isApp();
    }
  },
  mounted() {
    bus.$on("childrenData", childrenValue => {
      this.RechargeData = childrenValue;
      this.masterShow = childrenValue.masterShow;
      console.log(this.RechargeData);
    });
  }
};
</script>

<style scoped lang="scss">
.home {
  padding-top: 1px;

  // background: #fff;
  .logo_ {
    width: 240px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    p {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
    }

    img {
      width: 20px;
    }

    span {
      font-family: "微软雅黑";
      font-size: 20px;
      color: #3c3c3c;
      font-weight: 1000;
      margin-left: 10px;
    }
  }

  .logout {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);

    .logout_content {
      width: 400px;
      height: 300px;
      border-radius: 20px;
      background-color: #fff;
      color: #3c3c3c;
      font-family: Arial-BoldMT, Arial;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 70px 0;
      box-sizing: border-box;

      .tabs {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: block;
          width: 140px;
          height: 50px;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          color: #ffffff;
          margin: 10px;
          cursor: pointer;
        }

        span:first-child {
          background: linear-gradient(270deg, #ff2985 0%, #ffc794 100%);
        }

        span:nth-child(2) {
          color: #3c3c3c;
          background-color: #f3f1f7;
        }
      }
    }
  }

  .logout_btn {
    position: absolute;
    color: #3c3c3c;
    right: 0px;
    top: 0px;
    font-size: 16px;
    font-weight: 600;
    height: 80px;
    width: 40%;
    text-align: right;
    line-height: 80px;
    background: #fff;
    z-index: 0;
    padding-right: 60px;

    span {
      margin-left: 10px;
      color: #ff2388;
      cursor: pointer;
    }
  }

  color: #acacac;
  font-size: 18px;

  .text {
    text-align: center;
    color: #acacac;
    display: block;
    font-size: 18px;
    margin: 30px 0;
  }

  .options {
    width: 100%;
    height: 160px;

    p {
      display: flex;
      align-items: center;
      color: #3c3c3c;

      .icon {
        font-size: 26px;
        margin: 0 20px 0 30px;
        display: block;
      }

      #aside-tab {
        width: 10px;
        height: 80px;
        background: #000;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99;
      }

      b {
        position: absolute;
        right: 7px;
        top: 30px;
        width: 0;
        height: 0;
        border: 10px solid;
        border-color: #3c3c3c transparent transparent transparent;
        transform: rotate(-90deg);

        &::after {
          content: "";
          position: absolute;
          top: -13px;
          left: -10px;
          border: 10px solid;
          border-color: white transparent transparent transparent;
        }
      }

      &.recharge-icon-active {
        span {
          color: #ff2388;
        }
      }
    }

    .recharge-icon,
    .record-icon,
    .statistic-icon,
    .dailyrank-icon {
      margin: 0 10px 0 40px;
      display: block;
      width: 22px;
      height: 22px;
    }

    div {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      font-size: 18px;
      position: relative;
      font-family: Arial-BoldMT, Arial;
      cursor: pointer;
      background: url("../../assets/goto_grey.png");
      background-repeat: no-repeat;
      background-size: 12px 18px;
      background-position: 270px center;
    }

    .div_select {
      background-color: #fff;
      color: #ff2388;
      background: url("../../assets/goto.png");
      background-repeat: no-repeat;
      background-size: 12px 18px;
      background-position: 270px center;
    }

    .div_select:before {
      content: "";
      position: absolute;
      top: 0;
      height: 100%;
      left: 0;
      width: 10px;
      background-color: #ff2388;
    }
  }

  .master {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .master_content {
      width: 400px;
      // min-height: 300px;
      border-radius: 20px;
      background-color: #fff;
      display: flex;
      justify-self: start;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      box-sizing: border-box;
      padding-bottom: 24px;

      header {
        font-size: 18px;
        color: #3c3c3c;
        font-family: Arial-BoldMT, Arial;
        margin-bottom: 30px;
      }

      .userinfo {
        margin-bottom: 12px;
        width: 240px;
        // height: 80px;
        display: flex;
        justify-self: start;
        align-items: center;

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-left: 20px;
        }

        section {
          width: 140px;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          margin-left: 10px;

          span {
            display: block;
            width: 100%;
            height: 30px;
            line-height: 30px;
          }

          .username {
            color: #3c3c3c;
            font-size: 16px;
            font-family: ArialMT;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .id {
            font-size: 14px;
          }
        }
      }

      .buttons {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: block;
          width: 140px;
          height: 50px;
          border-radius: 40px;
          text-align: center;
          line-height: 50px;
          font-size: 14px;
          font-family: ArialMT;
          margin: 0 20px;
          cursor: pointer;
        }

        span:first-child {
          background: linear-gradient(270deg, #ff2985 0%, #ffc794 100%);
          color: #ffffff;
        }

        span:last-child {
          background-color: #f3f1f7;
          color: #3c3c3c;
        }
      }

      .items {
        width: 350px;
        min-height: 220px;
        background: #ebebeb;
        // background: ;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        padding-bottom: 16px;

        .info {
          width: 100%;
          // height: 24px;
          font-family: SourceHanSansSC, SourceHanSansSC;
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
          line-height: 14px;
          text-align: center;
          background-color: #232129;
          word-break: normal;
          padding: 5px 0;
        }

        .rewards {
          display: flex;
          justify-content: space-around;
          margin-top: 16px;

          &.received {
            filter: grayscale(1);
          }

          .re {
            width: 100px;
            text-align: center;

            span {
              font-family: SourceHanSansSC, SourceHanSansSC;
              font-weight: 500;
              font-size: 12px;
              color: #232129;
              line-height: 8px;
            }

            p {
              font-family: Akrobat, Akrobat;
              font-weight: 800;
              font-size: 12px;
              color: #000000;
              word-break: normal;

              img {
                width: 12px;
                height: 12px;
                display: inline-block;
                vertical-align: middle;
              }
            }
          }

          .ii {
            .img {
              width: 36px;
              height: 36px;
              background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
              border-radius: 6px;
              position: relative;
              margin: 0 auto;

              img {
                width: 28px;
                height: 28px;
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
              }
            }

            p {
              font-weight: 500;
              font-size: 14px;
              color: #232129;
              text-align: center;
              margin-top: 4px;
            }
          }
        }
      }
    }
  }

  .master1 {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .master_content {
      width: 400px;
      height: 300px;
      border-radius: 20px;
      background-color: #fff;
      display: flex;
      justify-self: start;
      flex-direction: column;
      align-items: center;
      padding-top: 80px;
      box-sizing: border-box;

      img {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
      }

      span {
        color: #3c3c3c;
        font-size: 18px;
        font-family: Arial-BoldMT, Arial;
      }
    }

    .master_content1 {
      width: 400px;
      height: 300px;
      border-radius: 20px;
      // background-color: #fff;
      display: flex;
      justify-self: start;
      flex-direction: column;
      align-items: center;
      padding-top: 110px;
      box-sizing: border-box;

      .recharging {
        color: #3c3c3c;
        font-size: 18px;
        font-family: Arial-BoldMT, Arial;
        margin-bottom: 20px;
      }

      span:last-child {
        color: #acacac;
        font-size: 16px;
        font-family: ArialMT;
      }
    }
  }
}

.el-select .el-input .el-select__caret {
  color: #3c3c3c;
}

.el-main {
  // margin-top: 30px;
  padding: 0;
}

@function rem($size, $rem: 37.5) {
  @return $size / $rem + rem;
}

@media screen and (max-width: 680px) {
  .home {
    .master {
      .master_content {
        width: rem(350);
        // min-height: rem(300);

        .items {
          width: rem(300);
          min-height: rem(220);
          padding-bottom: rem(24);
        }
      }
    }

    .master1 {
      .master_content {
        width: rem(350);
        height: rem(300);
      }

      .master_content1 {
        width: rem(350);
        height: rem(300);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/computer/home.vue